// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"67bcef21","885":"7b676929"}[chunkId] + ".chunk.js";
};